<template>
  <div class="personality">
    <banner part-id="personality" />
    <custom />
    <div :style="{ background: darkColor[darkType] }">
      <dark />
      <art v-if="showArt" ref="artRef" />
    </div>
    <relax v-if="vm.lang === 'zh'" />
  </div>
</template>

<script>
import Banner from '../Banner/PartBanner';
import Custom from './Custom';
import Dark from './Dark';
import Art from './Art+';
import Relax from './Relax';
export default {
  inject: {
    vm: { default: { config: {} } }
  },
  components: {
    Banner,
    Custom,
    Dark,
    Art,
    Relax
  },
  data() {
    return {
      darkType: 0,
      darkColor: ['#303030', '#212121', '#0d0d0d'],
      showArt: true
    };
  },
  watch: {
    'vm.config': {
      deeep: true,
      handler(val) {
        if (val.hideArtist && this.showArt === true) {
          this.$refs.artRef.destoryScene();
          this.showArt = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.personality {
  width: 100%;
  overflow: hidden;
}
</style>
